






























































































































import Vue from "vue";
import Component from "vue-class-component";
import { Getter, Action } from "vuex-class";

import Customer from "@/types/customer/Customer";
import UserInterface from "@/types/app/IUser";

import Endpoint from "@/utils/endpoint";

const namespace = "customer";

@Component({})
export default class ModalDetail extends Vue {
  @Getter("getModalInterestState", { namespace }) modalInterestState!: boolean;
  @Getter("getCustomer", { namespace }) customer!: Customer;
  @Getter("getLoading", { namespace }) loading!: boolean;
  @Getter("getUser", { namespace: "auth" }) user!: UserInterface;

  @Action("setLoading", { namespace }) setLoading!: any;
  @Action("setModalInterestState", { namespace }) setModalInterestState!: any;
  @Action("setModalRefuseState", { namespace }) setModalRefuseState!: any;
  @Action("setModalMessageState", { namespace }) setModalMessageState!: any;
  @Action("removeCustomerFromList", { namespace }) removeCustomerFromList!: any;

  private endpoint = new Endpoint();
  becoming = false;
  isLCM = false;

  

  becomeClient(): void {
   const roles = ["customer"];

   if(this.isLCM)
      roles.push("lcm");
    this.becoming = true;
    const {
      fullName,
      email,
      phone,
      relationship,
      investorType,
      comment,
      classification
    } = this.customer;

    this.$http
      .post(this.endpoint.createUser, {
        name: fullName,
        email,
        phone,
        relationship,
        investorType,
        comment,
        classification,
        roles: roles,
        id: this.customer.id
      })
      .then((resp: any) => {
        this.setUserId(resp.id, resp.token, resp.password);
      })
      .catch(err => {
        this.becoming = false;
        console.error(err);
      });
  }

  setUserId(id: string, token: string, password: string): void {
    this.$http
      .put(this.endpoint.acceptCustomer, {
        customerId: this.customer.id,
        token: token,
        password: password
      })
      .then(resp => {
        this.removeCustomerFromList({ id: this.customer.id, status: 1 });
        this.setLoading(false);
        this.setModalInterestState(false);
        this.setModalMessageState(true);
        this.becoming = false;
      })
      .catch(err => {
        console.error("error", err);

        this.becoming = false;
        this.setLoading(false);
      });
  }

  openExternalLink(link: string): void {
    if (link == null) return;
    window.open(link, "_blank");
  }

  showRefusement(): void {
    this.setModalRefuseState(true);
  }

  closeModal(): void {
    this.setModalInterestState(false);
  }
}
